import auth from '@client/components/auth';
import axios from 'axios';

export const httpClient = axios.create({
  baseURL: import.meta.env.VITE_CREATOR_API_URL,
});

httpClient.interceptors.request.use((config) => {
  const token = auth.getToken();
  if (token) {
    config.headers.Authorization = token;
  }
  return config;
});
